import CustomNotFoundPage from '@components/app/CustomNotFoundPage'
import { getParamsProvidedLayoutWithLayoutProps } from '@components/primitives/Layout/getPatientLayouts'
import { spacing } from '@lib/spacing'
import { getMainTopicsFromInterlinkingMaps } from '@modules/directoryTopics/helpers/cache/getCachedInterlinkingMapForTopics'
import type { InferGetStaticPropsType } from 'next'

export async function getStaticProps() {
  const interlinkingMaps = await getMainTopicsFromInterlinkingMaps()

  return {
    props: {
      interlinkingMaps,
    },
  }
}

function Custom404Page({
  interlinkingMaps,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return <CustomNotFoundPage interlinkingMaps={interlinkingMaps} />
}

Custom404Page.getLayout = getParamsProvidedLayoutWithLayoutProps({
  description: 'Page Not Found | Power Life Sciences, Inc.',
  spacing: spacing.small,
  title: 'Page Not Found',
})

export default Custom404Page
